import React, { useState } from 'react';
import { JSONPath } from 'jsonpath-plus';

const JSONPathFinder = () => {
    const [jsonInput, setJsonInput] = useState('');
    const [jsonPath, setJsonPath] = useState('');
    const [result, setResult] = useState('');
    const [error, setError] = useState('');
    const [copySuccess, setCopySuccess] = useState(false);

    const exampleJSON = `{
        "user": {
            "name": "Alice",
            "age": 30,
            "address": {
                "city": "New York",
                "zip": "10001"
            }
        }
    }`;
    const examplePath = '$.user.name';

    const findPath = () => {
        try {
            const parsedJSON = JSON.parse(jsonInput);
            const value = JSONPath({ path: jsonPath, json: parsedJSON });

            if (value.length === 0) {
                setResult('No results found for the given path.');
            } else {
                setResult(JSON.stringify(value, null, 2));
            }

            setError('');
            setCopySuccess(false);
        } catch (err) {
            setResult('');
            setError('Invalid JSON or JSON Path. Please check your input.');
            setCopySuccess(false);
        }
    };

    const clearInputs = () => {
        setJsonInput('');
        setJsonPath('');
        setResult('');
        setError('');
        setCopySuccess(false);
    };

    const useExampleData = () => {
        setJsonInput(exampleJSON);
        setJsonPath(examplePath);
        setResult('');
        setError('');
        setCopySuccess(false);
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(result);
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 2000);
    };

    return (
        <div className="container mt-4">
            <div className="text-center mb-3">
                <button className="btn btn-info" onClick={useExampleData}>
                    Use Example Data
                </button>
            </div>
            <div className="mb-3">
                <textarea
                    className="form-control"
                    rows="10"
                    value={jsonInput}
                    onChange={(e) => setJsonInput(e.target.value)}
                    placeholder="Enter JSON here..."
                    style={{ border: '2px solid #ccc', borderRadius: '5px' }}
                />
            </div>
            <div className="mb-3">
                <input
                    type="text"
                    className="form-control"
                    value={jsonPath}
                    onChange={(e) => setJsonPath(e.target.value)}
                    placeholder="Enter JSON Path (e.g., $.user.name)"
                    style={{ border: '2px solid #ccc', borderRadius: '5px' }}
                />
            </div>
            <div className="text-center">
                <button className="btn btn-success me-2" onClick={findPath}>
                    Find Path
                </button>
                <button className="btn btn-secondary" onClick={clearInputs}>
                    Clear
                </button>
            </div>
            {error && <p className="text-danger text-center mt-3">{error}</p>}
            {result && (
                <div className="mt-4">
                    <h5>Path Result</h5>
                    <pre
                        className="p-3"
                        style={{
                            backgroundColor: '#f5f5f5',
                            border: '1px solid #ccc',
                            borderRadius: '5px',
                        }}
                    >
                        {result}
                    </pre>
                    <div className="text-center mt-2">
                        <button
                            className={`btn ${copySuccess ? 'btn-success' : 'btn-primary'}`}
                            onClick={handleCopy}
                        >
                            {copySuccess ? 'Copied!' : 'Copy Result'}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default JSONPathFinder;